import { Divider, Drawer, Space, Slider, Checkbox, Button, Skeleton, Tooltip } from "antd";
import React, { useState } from "react";
import EditorPanelHeading from "../../UI/EditorPanelHeading";
import PresetPicker from "../../../globals/styles/PresetPicker";
import BMInput from "../../comps/BMInput";
import { PicRightOutlined, PicLeftOutlined, PicCenterOutlined } from '@ant-design/icons';
import ColourPicker from "../../../globals/styles/ColourPicker";
import { getColor } from "../../../utils/ConvertCSS";
import { useTemplate } from "../../../utils/Template";
import ButtonPicker from "../../../globals/styles/ButtonPicker";
import GiftCardSelector from "../../UI/GiftCardSelector";
import { PaddingHorizontalIcon, PaddingVerticalIcon } from "../../Icons";
import { tt_gci_gap, tt_gci_padding_x, tt_gci_padding_y, tt_gci_radius, tt_name_block_warning } from "../../../utils/Utils";
import SliderInput from "../../UI/SiderInput";


export default function GiftCard(props) {

    const { edit = false, close = () => { }, saveItem = () => { }, deleteItem = () => { }, id = 0 } = props;

    const [content, setContent] = useState(props.content);
    const [template,] = useTemplate();

    const [l, setL] = useState(false)
    const [r, setR] = useState(false);
    const [w, setW] = useState(false);

    const setData = (_data) => {
        setContent({ ...content, "data": _data })
    }

    // Component agnostic
    const {
        name = "",
        container = false,
        data = {},
        date_changed = 0
    } = content;

    // Component specific
    const {
        code = "",
        width = 800,
        align = "0 auto",
        radius = 15,
        padding_x = 20,
        padding_y = 20,
        gap = 20,
        shadow = true,
        button_type = 0,
        preset = 0,
        background = 0,
        button_block = false,
        card_width = 50,
        text_width = 50,
        text_align = "center"
    } = data;

    const save = () => {
        if (!name) {
            let _name = prompt(tt_name_block_warning);
            if (_name) {
                close();
                saveItem(id, { ...content, "name": _name });
            } else {
                return;
            }
        } else {
            close();
            saveItem(id, { ...content })
        }
    }

    const trash = () => {
        deleteItem(id);
        close();
    }

    const marks = {
        800: <small>800px</small>,
    };

    const drawRender = () => {

        // NEW
        let _style = {
            flexGrow: 1,
        }

        let bg_style = {

        }

        let containerStyle = {
            width: width + "px",
            border: (w) ? "4px solid deeppink" : "none",
            maxWidth: "100%",
            margin: align,
            padding: padding_y + "px " + padding_x + "px"
        }

        let _stack = "row";

        if (props.view === "phone") {
            _stack = "column-reverse";
        }


        if (r) {
            bg_style.borderRight = "4px solid deeppink";
        }

        const cardObj = window.giftcards.find(item => item.code === code) || { code: "", encrypted_code: "", description: "" }

        return (
            <>
                <div id={"bm-" + id} className={(container) ? "preview-container" : ""}>
                    <div style={{ background: getColor(background, template)}}>
                        <div style={containerStyle}>
                            <div style={{ display: 'flex', width: '100%', flexDirection: _stack, gap: gap + "px" }}>
                                <div style={{ ...bg_style, flex: '0 0 ' + card_width + "%", display: 'flex' }}>
                                    {(!code && <img onError={i => i.target.style.display = 'none'} style={{ width: "100%", objectFit: "cover", height: "150px" }} alt={name} src={" https://bookmanager.com/i/sample_content/placeholder.jpg"} />)}
                                    {(code && <img onError={i => i.target.style.display = 'none'} style={{ "width": "100%", "borderRadius": radius + "px", "boxShadow": (shadow) ? "0px 2px 5px 0px rgba(0,0,0,0.5)" : "none" }} src={"https://bookmanager.com/i/m.php?b=" + cardObj.encrypted_code} />)}
                                </div>
                                <div style={{ flex: '0 0 ' + (100 - card_width) + "%", display: 'flex', justifyContent: align }}>
                                    <div style={{ ..._style, border: (l) ? "4px solid deeppink" : "none" }}>
                                        {(!code &&
                                            <Skeleton />
                                        )}
                                        {(code &&
                                            <div>
                                                <h4 className={"bm-txt-" + preset}>{cardObj.description}</h4>
                                                <div className="shim" />
                                                <Button block={button_block} className={"bm-btn-" + button_type}>Add to Cart</Button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    const tipFormatter = (value) => {
        const remaining = 100 - value;
        return `${value} / ${remaining}`;
    };

    const splitmarks = {
        25: <small>25/75</small>,
        50: <small>50/50</small>,
        75: <small>75/25</small>,
    };


    const drawForm = () => {
        return (
            <>
                <EditorPanelHeading menus={props.menus} close={close} trash={trash} save={save} content={content} setContent={setContent} date_changed={date_changed} name={name} />

                {/* GIFT CARD */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">GIFT CARD</Divider>
                <GiftCardSelector value={code} onChange={(_v) => setData({ ...data, "code": _v.code })} />
                <div className="shim" /><div className="shim" />

                {/* BACKGROUND COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                <ColourPicker allow_gradient allow_none value={background} onChange={(_v) => setData({ ...data, "background": _v })} />
                <div className="shim" /> <div className="shim" />

                {/* WIDTH */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">WIDTH</Divider>
                <SliderInput
                    onBeforeChange={() => setW(true)}
                    onAfterChange={() => setW(false)}
                    width={170}
                    min={0}
                    suffix="PX"
                    max={1248}
                    onChange={(_v) => setData({ ...data, "width": _v })}
                    value={width}
                />

                {/* SPLIT */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">IMAGE & TEXT SPLIT</Divider>
                <div className="float-flex">
                    <div className="simple-label"><div className="shim" /><div className="shim" />IMAGE</div>
                    <Slider
                        className="rail"
                        onBeforeChange={() => { setR(true); setW(true) }}
                        onAfterChange={() => { setR(false); setW(false) }}
                        marks={splitmarks}
                        style={{ "width": "160px" }}
                        tipFormatter={tipFormatter}
                        min={20}
                        max={80}
                        onChange={(_v) => setData({ ...data, "card_width": _v })}
                        value={card_width}
                    />
                    <div className="simple-label"><div className="shim" /><div className="shim" />TEXT</div>
                </div>

                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">ALIGN</Divider>

                <Space>
                    <div><PicLeftOutlined onClick={() => setData({ ...data, "align": "0" })} style={{ "color": (align === "0") ? "#1890ff" : "#AAA" }} /></div>
                    <div><PicCenterOutlined onClick={() => setData({ ...data, "align": "0 auto" })} style={{ "color": (align === "0 auto") ? "#1890ff" : "#AAA" }} /></div>
                    <div><PicRightOutlined onClick={() => setData({ ...data, "align": "0 0 0 auto" })} style={{ "color": (align === "0 0 0 auto") ? "#1890ff" : "#AAA" }} /></div>
                </Space>
                <div className="shim" /><div className="shim" />

                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PADDING / GAP</Divider>
                <Space>
                    <BMInput width={35} value={padding_x} onChange={(_v) => setData({ ...data, "padding_x": _v })} number min={0} max={100} prefix={<Tooltip title={tt_gci_padding_x}><PaddingHorizontalIcon style={{ "color": "#888" }} /></Tooltip>} />
                    <BMInput width={35} value={padding_y} onChange={(_v) => setData({ ...data, "padding_y": _v })} number min={0} max={100} prefix={<Tooltip title={tt_gci_padding_y}><PaddingVerticalIcon style={{ "color": "#888" }} /></Tooltip>} />
                    <BMInput width={35} value={gap} onChange={(_v) => setData({ ...data, "gap": _v })} number min={0} max={100} prefix={<Tooltip title={tt_gci_gap}>GAP</Tooltip>} />
                </Space>
                <div className="shim" /><div className="shim" />

                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">CARD RADIUS / SHADOW</Divider>
                <div className="float-flex">
                    <BMInput width={"40px"} value={radius} onChange={(e) => setData({ ...data, "radius": e })} number min={0} max={1000} prefix={<Tooltip title={tt_gci_radius}>RADIUS</Tooltip>} />
                    <Checkbox checked={shadow} onClick={(e) => setData({ ...data, "shadow": e.target.checked })}><small>Shadow?</small></Checkbox>
                </div>
                <div className="shim" /> <div className="shim" />

                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">CARD TITLE PRESET</Divider>
                <PresetPicker value={preset} onChange={(e) => setData({ ...data, "preset": e })} />
                <div className="shim" /> <div className="shim" />

                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BUTTON PRESET</Divider>
                <ButtonPicker value={button_type} onChange={(e) => setData({ ...data, "button_type": e })} />
                <div className="shim" /> <div className="shim" />

                <Checkbox checked={button_block} onChange={(e) => setData({ ...data, "button_block": e.target.checked })} ><small>Fit Container?</small></Checkbox>
            </>
        )
    }

    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX": "hidden" }} closable={false} width={300} onClose={() => close(true)} open={edit}>
                {drawForm()}
            </Drawer>
            {drawRender()}
        </>
    )

}